import React, { Component } from 'react';

import TeachersGrid from './../component/TeachersGrid';
import MySelect from "./../component/select";

class Deeplearn extends Component{


  handelSelect = (e) => {
    if(e.name === 'subject') this.props.setSubject(e.value);
    if(e.name === 'class') this.props.setClass(e.value);
  };
  componentDidMount() {
    window.scrollTo(0, 0,);
    this.props.setSubject(null);
    this.props.setClass(null);
  }
  componentWillUnmount() {

  }
  render() {
    return (
      <div className="final">
        <img className="img"  src="https://imdproc-uploads-prod.s3.amazonaws.com/upload/custom-pages/im-ognakan/way/final.cut.jpg" alt=""/>
        <div className="intro">
          <h1 className="header ">Նախապատրաստում ցանկացած քննության և գրավոր աշխատանքի</h1>
          <p>
            Սիրելի՛ ծնողներ, ձեզ ենք ներկայացնում մի ծրագիր, որի շրջանակներում
            յուրաքանչյուր աշակերտ հնարավորություն կստանա իր գիտելիքները կառուցելու
            ճանապարհին ուղղորդվել այնպիսի մասնագետների կողմից, ովքեր լավագույններից են
            Հայաստանում։ Այսուհետև ձեր երեխան առանց տնից դուրս գալու կարող է պատրաստվել
            ցանկացած քննության և գրավոր աշխատանքի։
          </p>
        </div>

        <h3 className="header text-center">Ընտրեք դասարանն ու առարկան</h3>


        <div className="col-sm-3 "></div>
        <div className="col-sm-3 ">
          <MySelect
            name="subject"
            onChange={this.handelSelect}
            default="Առարկա"
            options={[
              "Մայրենի",
              "Մաթեմատիկա",
              "Կենսաբանություն",
              "Հայոց լեզու",
              "Հանրահաշիվ",
              "Երկրաչափություն",
              "Ֆիզիկա",
              "Քիմիա",
            ]}
          />
        </div>
        <div className="col-sm-3 ">
          <MySelect
            name="class"
            onChange={this.handelSelect}
            default="Դասարան"
            options={["4", "9", "10", "11", "12"]}
          />
        </div>
        <div className="col-sm-3"></div>
        <div className="polaceholder"></div>

        {(this.props.classNumber && this.props.subject) ?
          <TeachersGrid
            classNumber={this.props.classNumber}
            subject={this.props.subject}
            setTeacher={this.props.setTeacher}
          /> :
          <div></div>}
      </div>
    )
  }
}

export default Deeplearn;